import { Action, ActionCreator } from 'redux';
import { ReplyInterface } from './reply.interface';

export const REFREPLY = 'REFREPLY';
export interface RefReplyAction extends Action {
    reply: ReplyInterface;
}

export const CLEARREFREPLY = 'CLEARREFREPLY';
export interface ClearAction extends Action {
    reply: ReplyInterface;
}

export const clear: ActionCreator<ClearAction> =
    (reply) => ({
        type: CLEARREFREPLY,
        reply: reply
    });

export const refReply: ActionCreator<RefReplyAction> =
    (reply) => ({
        type: REFREPLY,
        reply: reply
    });
